<template>
    <v-container>
        <!-- Tela de carregamento -->
        <QuizLoadScreen :value="loading" />

        <!-- Escolha de Categoria -->
        <v-row v-if="!categorySelected" justify="center">
            <v-col cols="12" md="8">
                <h1>Escolha uma categoria:</h1>

                <!-- Caixa para inserir o nome do jogador -->
                <v-text-field
                    v-model="playerName"
                    label="Digite seu nome"
                    outlined
                    class="mb-4"></v-text-field>

                <!-- Seleção de categoria -->
                <v-select
                    v-model="selectedCategory"
                    :items="categories"
                    item-title="title"
                    item-value="id"
                    label="Categorias"
                    outlined></v-select>

                <!-- Botões de iniciar ou voltar ao início -->
                <v-btn
                    @click="selectCategory"
                    :disabled="!selectedCategory || !playerName"
                    color="primary"
                    class="mt-4">
                    Iniciar Quiz
                </v-btn>
                <span> &nbsp;</span>
                <v-btn
                    large
                    color="red"
                    class="mt-4"
                    @click="goToHome">
                    <v-icon left>mdi-help</v-icon>
                    Início
                </v-btn>
            </v-col>
        </v-row>

        <!-- Tela de Perguntas -->
        <v-row v-else>
            <v-col cols="12" class="text-center mb-4">
                <!-- Placar -->
                <section class="score">
                    <h2>
                        {{ playerName }} {{ win_count }} x {{ lose_count }}
                        {{ categoryName }}
                    </h2>
                </section>

                <!-- Barra de Progresso -->
                <v-progress-linear
                    :value="progress"
                    height="20"
                    color="primary"
                    class="my-4">
                    {{ Math.round(progress) }}%
                </v-progress-linear>
            </v-col>

            <!-- Exibição da pergunta -->
            <v-col
                cols="12"
                md="12"
                v-if="!quizFinished && question">
                <h1 v-html="question"></h1>

                <!-- Botões de Rádio para Respostas -->
                <v-radio-group
                    inline
                    v-model="chosen_answer"
                    class="mt-4"
                    :disabled="answerSubmitted">
                    <v-radio
                        v-for="(answer, index) in answers"
                        :key="index"
                        :label="answer.label"
                        :value="answer.value"
                        color="blue"></v-radio>
                </v-radio-group>

                <!-- Botão de confirmação -->
                <v-btn
                    v-if="!answerSubmitted"
                    @click="submitAnswer"
                    color="success"
                    class="mt-4">
                    Confirmar
                </v-btn>
            </v-col>

            <!-- Resultado da Pergunta -->
            <v-col
                cols="12"
                md="8"
                v-if="answerSubmitted && !quizFinished">
                <section class="result">
                    <template v-if="chosen_answer === correctAnswer">
                        <h4>✅ Parabéns, a resposta "{{ correctAnswer }}" está correta.</h4>
                    </template>
                    <template v-else>
                        <h4>❌ Que pena, a resposta está errada. A resposta correta é "{{ correctAnswer }}".</h4>
                    </template>
                    <v-btn
                        @click="getNewQuestion"
                        color="primary"
                        class="mt-4">
                        Próxima pergunta
                    </v-btn>
                    <v-btn
                        large
                        color="alert"
                        class="mt-4"
                        @click="goToHome">
                        <v-icon left>mdi-help-circle</v-icon>
                        Início
                    </v-btn>
                </section>
            </v-col>

            <!-- Final do Quiz -->
            <v-col
                cols="12"
                md="8"
                v-if="quizFinished">
                <h1>🎉 Parabéns, você completou o quiz!</h1>
                <h3>
                    Seu placar final foi: {{ playerName }} {{ win_count }} x
                    {{ lose_count }} {{ categoryName }}
                </h3>
                <v-btn
                    @click="goToStart"
                    color="primary"
                    class="mt-4">
                    Voltar ao início
                </v-btn>
                <v-btn
                    large
                    color="alert"
                    class="mt-4"
                    @click="goToHome">
                    <v-icon left>mdi-help</v-icon>
                    Início
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from "axios";
import {
    SignJWT,
    importPKCS8
} from "jose";
import QuizLoadScreen from "./QuizLoadScreen.vue";

export default {
    name: "App",
    components: {
        QuizLoadScreen,
    },
    data() {
        return {
            loading: false,
            playerName: "",
            chosen_answer: undefined,
            question: undefined,
            incorrectAnswers: [],
            answers: [], // Armazena as opções para os botões de rádio
            correctAnswer: "",
            win_count: 0,
            lose_count: 0,
            answerSubmitted: false,
            categories: [],
            selectedCategory: null,
            categoryName: "",
            categorySelected: false,
            questions: [],
            questionsAnswered: [],
            quizFinished: false,

            sheetId: "1Fsk3hD-LmpcHTs0EIBQ6V7Xb7qQcNCPtodmVCyXnQCc",
            serviceAccountEmail: "games-hab@compartilhar-planilhas-443921.iam.gserviceaccount.com",
            privateKey: "", // Carregado dinamicamente
        };
    },

    computed: {

        progress() {
            return (this.questionsAnswered.length / this.questions.length) * 100;
        },
    },

    methods: {
        submitAnswer() {
            if (!this.chosen_answer) {
                alert("Escolha uma das opções");
            } else {
                this.answerSubmitted = true;
                if (this.chosen_answer === this.correctAnswer) {
                    this.win_count++;
                } else {
                    this.lose_count++;
                }
                this.questionsAnswered.push(this.question); // Adiciona a pergunta ao array de respondidas
                if (this.questionsAnswered.length === this.questions.length) {
                    this.quizFinished = true; // Finaliza o quiz
                }
            }
        },
        shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        },
        goToHome() {
            this.$router.push("/");
        },
        async loadPrivateKey() {
            try {
                const keyFile = await fetch("/assets/keys/credentials.json");
                const json = await keyFile.json();
                this.privateKey = json.private_key;
            } catch (error) {
                console.error("Erro ao carregar chave privada:", error);
            }
        },
        async generateJwt() {
            try {
                const privateKey = await importPKCS8(this.privateKey, "RS256");
                const jwt = await new SignJWT({
                        iss: this.serviceAccountEmail,
                        scope: "https://www.googleapis.com/auth/spreadsheets",
                        aud: "https://oauth2.googleapis.com/token",
                    })
                    .setProtectedHeader({
                        alg: "RS256"
                    })
                    .setIssuedAt()
                    .setExpirationTime("1h")
                    .sign(privateKey);

                const response = await axios.post("https://oauth2.googleapis.com/token", {
                    grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
                    assertion: jwt,
                });

                return response.data.access_token;
            } catch (error) {
                console.error("Erro ao gerar JWT:", error);
                throw new Error("Falha ao gerar JWT");
            }
        },
        async fetchCategories() {
            try {
                const response = await axios.get(
                    "https://opentdb.com/api_category.php"
                );

                this.categories = await Promise.all(
                    response.data.trivia_categories.map(async (category) => ({
                        id: category.id,
                        title: await this.translateText(category.name),
                    }))
                );

                // console.log("Categorias carregadas:", this.categories);
            } catch (error) {
                console.error("Erro ao carregar categorias:", error);
            }
        },
        async ensureSheetExists(sheetName) {
            try {
                const token = await this.generateJwt();

                // Verifica se a aba já existe
                const response = await axios.get(
                    `https://sheets.googleapis.com/v4/spreadsheets/${this.sheetId}`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                const sheetExists = response.data.sheets.some(
                    (sheet) => sheet.properties.title === sheetName
                );

                if (!sheetExists) {
                    // Cria a aba
                    await axios.post(
                        `https://sheets.googleapis.com/v4/spreadsheets/${this.sheetId}:batchUpdate`, {
                            requests: [{
                                addSheet: {
                                    properties: {
                                        title: sheetName
                                    },
                                },
                            }, ],
                        }, {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        }
                    );

                    console.log(`Aba "${sheetName}" criada.`);

                    // Adiciona os nomes das colunas
                    await axios.post(
                        `https://sheets.googleapis.com/v4/spreadsheets/${this.sheetId}/values/${sheetName}!A1:G1:append?valueInputOption=USER_ENTERED`, {
                            range: `${sheetName}!A1:G1`,
                            values: [
                                [
                                    "Nro.",
                                    "Pergunta (EN)",
                                    "Resposta Correta (EN)",
                                    "Opções (EN)",
                                    "Pergunta (PT)",
                                    "Resposta Correta (PT)",
                                    "Opções (PT)",
                                ],
                            ],
                        }, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );

                    console.log(`Colunas adicionadas na aba "${sheetName}".`);

                    return 1; // Retorna 1 como próximo número inicial
                } else {
                    // Se a aba já existir, busca o último número na coluna "Nro."
                    const rowsResponse = await axios.get(
                        `https://sheets.googleapis.com/v4/spreadsheets/${this.sheetId}/values/${sheetName}!A:A`, {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        }
                    );

                    const rows = rowsResponse.data.values || [];
                    const lastRow = rows.length > 1 ? rows[rows.length - 1][0] : "0";

                    // Retorna o próximo número sequencial
                    const nextNumber = parseInt(lastRow, 10) + 1;
                    console.log(`Próximo número na sequência: ${nextNumber}`);
                    return nextNumber;
                }
            } catch (error) {
                console.error("Erro ao verificar/criar aba:", error);
                throw new Error("Erro ao verificar/criar aba");
            }
        },
        async fetchQuestionsFromSheet(sheetName) {
            try {
                const token = await this.generateJwt();
                const response = await axios.get(
                    `https://sheets.googleapis.com/v4/spreadsheets/${this.sheetId}/values/${sheetName}!A:G`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                return response.data.values || [];
            } catch (error) {
                console.error("Erro ao buscar perguntas da planilha:", error);
                return [];
            }
        },
        async addQuestionsToSheet(sheetName, questions) {
            try {
                const token = await this.generateJwt();

                // Obtém os dados existentes na planilha
                const existingData = await this.fetchQuestionsFromSheet(sheetName);

                // Determina o próximo número com base no total existente
                let existingCount = 1; // Começa do 1
                if (existingData.length > 1) {
                    const validNumbers = existingData
                        .map((row) => parseInt(row[0], 10)) // Extrai os números da coluna "Nro."
                        .filter((num) => !isNaN(num) && num > 0); // Remove valores inválidos ou negativos

                    if (validNumbers.length > 0) {
                        existingCount = Math.max(...validNumbers) + 1; // Próximo número válido
                    }
                }

                // Adiciona numeração sequencial às novas perguntas
                const rows = questions.map((q, index) => [
                    existingCount + index, // Número sequencial
                    q.question, // Pergunta (EN)
                    q.correct_answer, // Resposta Correta (EN)
                    q.incorrect_answers.join("|| "), // Opções (EN)
                    q.translated_question, // Pergunta (PT)
                    q.translated_correct_answer, // Resposta Correta (PT)
                    q.translated_incorrect_answers.join("|| "), // Opções (PT)
                ]);

                // Envia as linhas para a planilha
                await axios.post(
                    `https://sheets.googleapis.com/v4/spreadsheets/${this.sheetId}/values/${sheetName}!A:G:append?valueInputOption=USER_ENTERED`, {
                        values: rows
                    }, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

            } catch (error) {
                console.error("Erro ao adicionar perguntas à planilha:", error);
            }
        },
        async fetchQuestions() {
            try {
                const response = await axios.get(
                    `https://opentdb.com/api.php?amount=10&category=${this.selectedCategory}`
                );
                const rawQuestions = response.data.results;

                const sheetName = this.categoryName;
                await this.ensureSheetExists(sheetName);

                // Obtendo as perguntas existentes
                const existingQuestions = await this.fetchQuestionsFromSheet(sheetName);
                const existingQuestionsText = existingQuestions.map((row) => row[1]); // Coluna Pergunta (EN)

                const newQuestions = [];

                // Processando as novas perguntas
                this.questions = await Promise.all(
                    rawQuestions.map(async (q) => {
                        if (existingQuestionsText.includes(q.question)) {
                            // Se a pergunta já existe, carrega as traduções da planilha
                            const existingRow = existingQuestions.find(
                                (row) => row[1] === q.question // Coluna Pergunta (EN)
                            );
                            return {
                                question: existingRow[4], // Pergunta (PT)
                                correct_answer: existingRow[5], // Resposta Correta (PT)
                                incorrect_answers: existingRow[6].split("|| "), // Opções (PT)
                            };
                        } else {
                            // Traduzindo as perguntas e adicionando à lista de novas perguntas
                            const translatedQuestion = await this.translateText(q.question);
                            const translatedCorrectAnswer = await this.translateText(
                                q.correct_answer
                            );
                            const translatedIncorrectAnswers = await Promise.all(
                                q.incorrect_answers.map((answer) =>
                                    this.translateText(answer)
                                )
                            );

                            newQuestions.push({
                                question: q.question,
                                correct_answer: q.correct_answer,
                                incorrect_answers: q.incorrect_answers,
                                translated_question: translatedQuestion,
                                translated_correct_answer: translatedCorrectAnswer,
                                translated_incorrect_answers: translatedIncorrectAnswers,
                            });

                            return {
                                question: translatedQuestion,
                                correct_answer: translatedCorrectAnswer,
                                incorrect_answers: translatedIncorrectAnswers,
                            };
                        }
                    })
                );

                // Adiciona as novas perguntas à planilha de uma vez
                if (newQuestions.length > 0) {
                    await this.addQuestionsToSheet(sheetName, newQuestions);
                }

                this.getNewQuestion();
            } catch (error) {
                console.error("Erro ao carregar perguntas:", error);
            }
        },
        async translateText(text) {
            try {
                const response = await axios.post(
                    "https://translation.googleapis.com/language/translate/v2", {
                        q: text,
                        target: "pt"
                    }, {
                        params: {
                            key: "AIzaSyArxVuAL1axXJPICiKilVTHHYL2aMeYrfg"
                        },
                    }
                );

                return response.data.data.translations[0].translatedText;
            } catch (error) {
                console.error("Erro ao traduzir texto:", error);
                return text; // Retorna o texto original caso haja erro
            }
        },
        selectCategory() {
            this.categorySelected = true;
            const category = this.categories.find(
                (cat) => cat.id === this.selectedCategory
            );
            this.categoryName = category ? category.title : "Categoria";
            this.loading = true;

            this.fetchQuestions().finally(() => {
                this.loading = false;
            });
        },
        getNewQuestion() {
            this.chosen_answer = undefined;
            this.answerSubmitted = false;

            if (this.questionsAnswered.length < this.questions.length) {
                const remainingQuestions = this.questions.filter(
                    (q) => !this.questionsAnswered.includes(q.question)
                );
                const nextQuestion = remainingQuestions[0];

                if (nextQuestion) {
                    this.question = nextQuestion.question;
                    this.correctAnswer = nextQuestion.correct_answer;
                    this.incorrectAnswers = nextQuestion.incorrect_answers;

                    // Combine a resposta correta com as incorretas e embaralhe
                    const allAnswers = [this.correctAnswer, ...this.incorrectAnswers];
                    this.answers = this.shuffleArray(
                        allAnswers.map((answer) => ({
                            label: answer, // Texto a ser exibido no botão
                            value: answer, // Valor selecionável
                        }))
                    );
                    allAnswers.forEach((answer) => console.log("Adicionando linha:", answer));

                } else {
                    console.error("Erro: Próxima pergunta não encontrada.");
                }
            } else {
                this.quizFinished = true;
            }
        },

    },

    async created() {
        await this.loadPrivateKey();
        await this.fetchCategories();
    },
};
</script>

<style scoped>
.score {
    border-bottom: 1px solid black;
    padding: 24px;
    font-size: 24px;
    /* Aumentado para maior destaque */
    font-weight: bold;
}

.v-radio-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.v-radio {
    margin: 5px 0;
}
</style>
